var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 379.595,
    y2: 479.358
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 408.428,
    y2: 302.387
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.215,
    x2: 287.551,
    xlinkHref: "#lg1",
    y1: 94.289,
    y2: 319.35
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.608,
    x2: 205.218,
    xlinkHref: "#lg2",
    y1: 239.882,
    y2: 48.059
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 49.099,
    y2: 190.981
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 169.904,
    y2: -71.091
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.029,
    x2: 190.268,
    xlinkHref: "#lg4",
    y1: 79.396,
    y2: 37.432
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.559,
    x2: 197.688,
    xlinkHref: "#lg2",
    y1: 288.835,
    y2: 136.964
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.873,
    x2: 319.311,
    xlinkHref: "#lg1",
    y1: 167.173,
    y2: 260.611
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7b667b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.833,
    x2: 256.327,
    xlinkHref: "#lg5",
    y1: 156.098,
    y2: 158.592
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.833,
    x2: 256.327,
    xlinkHref: "#lg5",
    y1: 234.167,
    y2: 236.661
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 1 -1 0 -3214 -5852)",
    gradientUnits: "userSpaceOnUse",
    x1: 6047.132,
    x2: 6049.627,
    xlinkHref: "#lg5",
    y1: -3509.202,
    y2: -3506.708
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 1 -1 0 -3214 -5852)",
    gradientUnits: "userSpaceOnUse",
    x1: 6047.132,
    x2: 6049.627,
    xlinkHref: "#lg5",
    y1: -3431.133,
    y2: -3428.638
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(.868 .496 -.496 .868 -2075.941 -1252.417)",
    gradientUnits: "userSpaceOnUse",
    x1: 2741.443,
    x2: 2743.938,
    xlinkHref: "#lg5",
    y1: 60.555,
    y2: 63.049
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.868 .496 -.496 .868 -2075.941 -1252.417)",
    gradientUnits: "userSpaceOnUse",
    x1: 2741.443,
    x2: 2743.938,
    xlinkHref: "#lg5",
    y1: 138.624,
    y2: 141.119
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.496 .868 -.868 -.496 -1961.583 -7927.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 5951.59,
    x2: 5954.084,
    xlinkHref: "#lg5",
    y1: -5996.813,
    y2: -5994.318
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-.496 .868 -.868 -.496 -1961.583 -7927.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 5951.59,
    x2: 5954.084,
    xlinkHref: "#lg5",
    y1: -5918.744,
    y2: -5916.249
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-.868 .496 .496 .868 4713.941 -1252.417)",
    gradientUnits: "userSpaceOnUse",
    x1: 4588.83,
    x2: 4591.324,
    xlinkHref: "#lg5",
    y1: -995.64,
    y2: -993.146
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.868 .496 .496 .868 4713.941 -1252.417)",
    gradientUnits: "userSpaceOnUse",
    x1: 4588.83,
    x2: 4591.324,
    xlinkHref: "#lg5",
    y1: -917.571,
    y2: -915.076
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.496 .868 .868 -.496 4599.583 -7927.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 4895.395,
    x2: 4897.889,
    xlinkHref: "#lg5",
    y1: -7844.199,
    y2: -7841.705
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(.496 .868 .868 -.496 4599.583 -7927.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 4895.395,
    x2: 4897.889,
    xlinkHref: "#lg5",
    y1: -7766.13,
    y2: -7763.635
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#e9d6f7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#c5b5de",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#aa9bcb",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688bd",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8a7db5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.611,
    x2: 163.89,
    xlinkHref: "#lg6",
    y1: 211.457,
    y2: 145.089
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.117,
    x2: 212.985,
    xlinkHref: "#lg6",
    y1: 215.417,
    y2: 154.285
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.466,
    x2: 320.209,
    xlinkHref: "#lg7",
    y1: 166.766,
    y2: 261.509
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.824,
    x2: 196.038,
    xlinkHref: "#lg7",
    y1: 246.124,
    y2: 137.338
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.92,
    x2: 263.954,
    xlinkHref: "#lg8",
    y1: 175.228,
    y2: 175.228
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(.707 .707 .707 -.707 3591.641 -8670.989)",
    gradientUnits: "userSpaceOnUse",
    x1: 3902.678,
    x2: 3919.713,
    xlinkHref: "#lg8",
    y1: -8645.076,
    y2: -8645.076
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.863,
    x2: 266.343,
    xlinkHref: "#lg9",
    y1: 191.162,
    y2: 207.643
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.855,
    x2: 127.874,
    xlinkHref: "#lg1",
    y1: 251.652,
    y2: 312.671
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.487,
    x2: 92.101,
    xlinkHref: "#lg2",
    y1: 296.215,
    y2: 202.453
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.323,
    x2: 89.323,
    xlinkHref: "#lg3",
    y1: 190.708,
    y2: 249.283
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.195,
    x2: 18.417,
    xlinkHref: "#lg2",
    y1: 300.985,
    y2: 227.207
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3793,
    stopColor: "#1accfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5998,
    stopColor: "#22c3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#2fb5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9365,
    stopColor: "#41a1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.29,
    x2: 75.656,
    xlinkHref: "#lg10",
    y1: 248.362,
    y2: 284.728
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.952,
    x2: 79.104,
    xlinkHref: "#lg2",
    y1: 302.073,
    y2: 236.225
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.579,
    x2: 123.652,
    xlinkHref: "#lg10",
    y1: 252.982,
    y2: 281.055
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.126,
    x2: 435.987,
    xlinkHref: "#lg1",
    y1: 247.8,
    y2: 303.661
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-1 0 0 1 5134.368 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 4713.691,
    x2: 4713.691,
    xlinkHref: "#lg3",
    y1: 190.708,
    y2: 249.283
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.318,
    x2: 335.54,
    xlinkHref: "#lg2",
    y1: 300.985,
    y2: 227.207
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.412,
    x2: 392.779,
    xlinkHref: "#lg10",
    y1: 248.362,
    y2: 284.728
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.075,
    x2: 396.227,
    xlinkHref: "#lg2",
    y1: 302.073,
    y2: 236.225
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.702,
    x2: 440.774,
    xlinkHref: "#lg10",
    y1: 252.982,
    y2: 281.055
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg7",
    y1: 314.666,
    y2: 342.9
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.894,
    x2: 211.458,
    xlinkHref: "#lg1",
    y1: 422.286,
    y2: 403.88
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.329,
    x2: 222.855,
    xlinkHref: "#lg9",
    y1: 424.632,
    y2: 411.053
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.272,
    x2: 238.383,
    y1: 416.2,
    y2: 409.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg7",
    y1: 437.057,
    y2: 465.291
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.006,
    x2: 23.485,
    xlinkHref: "#lg2",
    y1: 409.746,
    y2: 338.224
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg11"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#1accfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6187,
    stopColor: "#21c4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    stopColor: "#2db6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9294,
    stopColor: "#3fa4f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.682,
    x2: 79.936,
    xlinkHref: "#lg11",
    y1: 359.421,
    y2: 394.675
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.149,
    x2: 82.316,
    xlinkHref: "#lg2",
    y1: 410.8,
    y2: 346.967
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.249,
    x2: 126.463,
    xlinkHref: "#lg11",
    y1: 363.9,
    y2: 391.114
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.172,
    x2: 114.611,
    xlinkHref: "#lg2",
    y1: 407.734,
    y2: 329.173
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 149,
    x2: 171.842,
    xlinkHref: "#lg11",
    y1: 363.562,
    y2: 386.404
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.002,
    x2: 288.48,
    xlinkHref: "#lg2",
    y1: 409.746,
    y2: 338.224
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.677,
    x2: 344.931,
    xlinkHref: "#lg11",
    y1: 359.421,
    y2: 394.675
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.144,
    x2: 347.311,
    xlinkHref: "#lg2",
    y1: 410.8,
    y2: 346.967
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.245,
    x2: 391.459,
    xlinkHref: "#lg11",
    y1: 363.9,
    y2: 391.114
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.167,
    x2: 379.606,
    xlinkHref: "#lg2",
    y1: 407.734,
    y2: 329.173
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.995,
    x2: 436.837,
    xlinkHref: "#lg11",
    y1: 363.562,
    y2: 386.404
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg12"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.728,
    x2: 62.303,
    xlinkHref: "#lg12",
    y1: 406.2,
    y2: 470.038
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.736,
    x2: 482.217,
    xlinkHref: "#lg12",
    y1: 418.596,
    y2: 482.384
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.507,
    x2: 431.868,
    y1: 436.485,
    y2: 470.567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#b3d100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#9fb900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#7e9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.2 337.824h447.601v126.133h-447.601z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.2 337.824v4.653l121.479 121.48h326.121v-126.133z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.413 342.477h-202.826v-192.283l101.413-99.823 101.413 99.823z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 50.371-101.413 99.823v16.804l175.479 175.479h27.347v-192.283z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m374.475 159.803-111.275-111.274c-4.529-4.529-11.872-4.529-16.4 0l-111.275 111.274c-2.655 2.655-.775 7.195 2.98 7.195h24.311c6.088 0 11.927-2.418 16.232-6.723l71.946-71.946c2.212-2.212 5.799-2.212 8.011 0l71.946 71.946c4.305 4.305 10.144 6.723 16.232 6.723h24.311c3.756 0 5.636-4.539 2.981-7.195z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.048 160.275 71.946-71.946c2.212-2.212 5.799-2.212 8.011 0l71.946 71.946c4.305 4.305 10.144 6.723 16.232 6.723h14.14l-98.123-98.123c-4.529-4.529-11.872-4.529-16.4 0l-98.124 98.124h14.14c6.089-.001 11.927-2.419 16.232-6.724z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.006 88.329 71.946 71.946c4.305 4.305 10.144 6.723 16.232 6.723h24.311c3.755 0 5.635-4.54 2.98-7.195l-111.275-111.274c-2.264-2.264-5.232-3.397-8.2-3.397v41.538c1.45 0 2.9.553 4.006 1.659z",
    fill: "url(#SVGID_7_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m356.413 213.741-58.749-56.9c-10.441-10.99-25.195-17.456-41.551-17.456-31.394 0-56.916 25.523-56.915 56.916 0 16.356 6.465 31.11 17.456 41.55l104.626 104.626h35.133z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 196.3,
    fill: "url(#SVGID_9_)",
    r: 56.514
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 157.265,
    fill: "url(#SVGID_10_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 235.334,
    fill: "url(#SVGID_11_)",
    r: 2.973
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 294.035,
    cy: 196.3,
    fill: "url(#SVGID_12_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.965,
    cy: 196.3,
    fill: "url(#SVGID_13_)",
    r: 2.973
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 274.374,
    cy: 162.413,
    fill: "url(#SVGID_14_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.626,
    cy: 230.187,
    fill: "url(#SVGID_15_)",
    r: 2.973
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 288.887,
    cy: 215.674,
    fill: "url(#SVGID_16_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.113,
    cy: 176.926,
    fill: "url(#SVGID_17_)",
    r: 2.973
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 235.626,
    cy: 162.413,
    fill: "url(#SVGID_18_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.374,
    cy: 230.187,
    fill: "url(#SVGID_19_)",
    r: 2.973
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 221.113,
    cy: 215.674,
    fill: "url(#SVGID_20_)",
    r: 2.973
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.887,
    cy: 176.926,
    fill: "url(#SVGID_21_)",
    r: 2.973
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m310.309 207.949-51.978-51.978c-.707-1.092-1.934-1.816-3.331-1.816-2.192 0-3.969 1.777-3.969 3.969v29.031c-3.53 1.534-5.999 5.05-5.999 9.144 0 1.292.249 2.526.696 3.659l-12.782 12.782c-1.55 1.55-1.55 4.063 0 5.613l33.42 33.317c21.998-4.492 39.342-21.764 43.943-43.721z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.369 228.611-38.843-38.843c-1.828-2.104-4.521-3.437-7.526-3.437-5.505 0-9.968 4.463-9.968 9.968 0 3.006 1.332 5.699 3.437 7.526l38.842 38.842c5.473-3.819 10.238-8.583 14.058-14.056z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 138.997c-31.648 0-57.303 25.655-57.303 57.303s25.655 57.303 57.303 57.303 57.303-25.655 57.303-57.303-25.655-57.303-57.303-57.303zm0 103.904c-25.738 0-46.601-20.863-46.601-46.601s20.863-46.601 46.601-46.601 46.601 20.863 46.601 46.601-20.863 46.601-46.601 46.601z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 248.333c28.738 0 52.033-23.295 52.033-52.033s-23.295-52.033-52.033-52.033-52.033 23.295-52.033 52.033 23.295 52.033 52.033 52.033zm0-98.634c25.738 0 46.601 20.863 46.601 46.601s-20.863 46.601-46.601 46.601-46.601-20.863-46.601-46.601 20.863-46.601 46.601-46.601z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 196.3c-2.192 0-3.969-1.777-3.969-3.969v-34.206c0-2.192 1.777-3.969 3.969-3.969 2.192 0 3.969 1.777 3.969 3.969v34.206c0 2.192-1.777 3.969-3.969 3.969z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 196.3c-1.55-1.55-4.063-1.55-5.613 0l-16.44 16.44c-1.55 1.55-1.55 4.063 0 5.613 1.55 1.55 4.063 1.55 5.613 0l16.44-16.44c1.55-1.55 1.55-4.063 0-5.613z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 196.3,
    fill: "url(#SVGID_28_)",
    r: 9.968
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.199 219.994h130.478v122.484h-130.478z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.678 342.477v-122.483h-130.479v14.558l107.926 107.925z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.678 234.552h-135.541c-7.117 0-11.512-7.767-7.847-13.868l20.578-34.253c3.149-5.241 8.816-8.448 14.93-8.448h107.879v56.569z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.479 259.697c-1.686-1.89-4.133-2.446-6.866-2.446h-19.585c-5.085 0-8.567 3.481-8.567 8.567v19.586c0 2.732.556 5.18 2.446 6.866l23.442 23.442c1.686 1.89 4.133 3.087 6.866 3.087h19.585c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-2.733-1.197-5.18-3.087-6.866z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.62 255.898h-19.585c-5.085 0-9.208 4.123-9.208 9.208v19.586c0 5.085 4.123 9.208 9.208 9.208h19.585c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-5.085-4.122-9.208-9.208-9.208z",
    fill: "url(#SVGID_33_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m135.148 259.697c-1.686-1.89-4.133-2.446-6.866-2.446h-19.586c-5.085 0-8.567 3.481-8.567 8.567v19.586c0 2.732.556 5.18 2.446 6.866l23.442 23.442c1.686 1.89 4.133 3.087 6.866 3.087h19.586c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-2.733-1.197-5.18-3.087-6.866z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m127.289 293.9h-19.586c-5.085 0-9.208-4.123-9.208-9.208v-19.586c0-5.085 4.123-9.208 9.208-9.208h19.586c5.085 0 9.208 4.123 9.208 9.208v19.586c0 5.086-4.122 9.208-9.208 9.208z",
    fill: "url(#SVGID_35_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.323 219.994h130.478v122.484h-130.478z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.323 234.552h135.541c7.117 0 11.512-7.767 7.847-13.868l-20.578-34.253c-3.149-5.241-8.816-8.448-14.93-8.448h-107.88z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400.602 259.697c-1.686-1.89-4.133-2.446-6.866-2.446h-19.586c-5.085 0-8.567 3.481-8.567 8.567v19.586c0 2.732.556 5.18 2.446 6.866l23.442 23.442c1.686 1.89 4.133 3.087 6.866 3.087h19.586c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-2.733-1.197-5.18-3.087-6.866z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.743 255.898h-19.586c-5.085 0-9.208 4.123-9.208 9.208v19.586c0 5.085 4.123 9.208 9.208 9.208h19.586c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-5.085-4.122-9.208-9.208-9.208z",
    fill: "url(#SVGID_39_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.271 259.697c-1.686-1.89-4.133-2.446-6.866-2.446h-19.585c-5.085 0-8.567 3.481-8.567 8.567v19.586c0 2.732.556 5.18 2.446 6.866l23.442 23.442c1.686 1.89 4.133 3.087 6.866 3.087h19.586c5.085 0 9.208-4.123 9.208-9.208v-19.586c0-2.733-1.197-5.18-3.087-6.866z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m444.412 293.9h-19.586c-5.085 0-9.208-4.123-9.208-9.208v-19.586c0-5.085 4.123-9.208 9.208-9.208h19.586c5.085 0 9.208 4.123 9.208 9.208v19.586c0 5.086-4.122 9.208-9.208 9.208z",
    fill: "url(#SVGID_41_)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m480.601 342.477h-451.202c-4.108 0-7.439-3.331-7.439-7.439v-15.067c0-4.108 3.331-7.439 7.439-7.439h451.202c4.108 0 7.439 3.331 7.439 7.439v15.067c0 4.109-3.331 7.439-7.439 7.439z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.941 463.957h-79.882v-97.133c0-5.546 4.496-10.042 10.042-10.042h59.799c5.546 0 10.042 4.496 10.042 10.042v97.133z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.014 463.957h-56.028v-89.121c0-3.893 3.156-7.049 7.049-7.049h41.931c3.893 0 7.049 3.156 7.049 7.049v89.121z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 463.957h28.014v-89.121c0-3.893-3.156-7.049-7.049-7.049h-20.965z",
    fill: "url(#SVGID_45_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m480.601 464.868h-451.202c-4.108 0-7.439-3.331-7.439-7.439v-15.067c0-4.108 3.331-7.439 7.439-7.439h451.202c4.108 0 7.439 3.331 7.439 7.439v15.067c0 4.108-3.331 7.439-7.439 7.439z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m86.557 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.987c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_47_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.901 366.727h-18.987c-4.93 0-8.926 3.997-8.926 8.926v18.987c0 4.93 3.996 8.926 8.926 8.926h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-4.929-3.996-8.926-8.926-8.926z",
    fill: "url(#SVGID_48_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m136.645 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.987c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_49_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m129.99 403.567h-18.987c-4.93 0-8.926-3.996-8.926-8.926v-18.987c0-4.93 3.996-8.926 8.926-8.926h18.987c4.93 0 8.926 3.996 8.926 8.926v18.987c0 4.929-3.997 8.926-8.926 8.926z",
    fill: "url(#SVGID_50_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m186.734 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.987c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_51_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m180.078 403.567h-18.987c-4.93 0-8.926-3.996-8.926-8.926v-18.987c0-4.93 3.996-8.926 8.926-8.926h18.987c4.93 0 8.926 3.996 8.926 8.926v18.987c.001 4.929-3.996 8.926-8.926 8.926z",
    fill: "url(#SVGID_52_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.552 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.986c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_53_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.896 366.727h-18.986c-4.93 0-8.926 3.997-8.926 8.926v18.987c0 4.93 3.996 8.926 8.926 8.926h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-4.929-3.997-8.926-8.927-8.926z",
    fill: "url(#SVGID_54_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m401.641 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.987c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_55_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m394.985 403.567h-18.987c-4.93 0-8.926-3.996-8.926-8.926v-18.987c0-4.93 3.996-8.926 8.926-8.926h18.987c4.93 0 8.926 3.996 8.926 8.926v18.987c0 4.929-3.996 8.926-8.926 8.926z",
    fill: "url(#SVGID_56_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.729 369.72c-1.635-1.832-4.007-2.371-6.656-2.371h-18.987c-4.93 0-8.305 3.375-8.305 8.305v18.987c0 2.649.539 5.021 2.371 6.656l22.725 22.725c1.635 1.832 4.007 2.993 6.656 2.993h18.987c4.93 0 8.926-3.996 8.926-8.926v-18.987c0-2.649-1.16-5.021-2.993-6.656z",
    fill: "url(#SVGID_57_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m445.073 403.567h-18.987c-4.93 0-8.926-3.996-8.926-8.926v-18.987c0-4.93 3.996-8.926 8.926-8.926h18.987c4.93 0 8.926 3.996 8.926 8.926v18.987c.001 4.929-3.996 8.926-8.926 8.926z",
    fill: "url(#SVGID_58_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m88.868 464.868h-73.726c-8.363 0-15.142-6.78-15.142-15.143v-7.075c0-24.54 19.894-44.434 44.434-44.434 24.54 0 44.434 19.894 44.434 44.434z",
    fill: "url(#SVGID_59_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.909 464.868h71.422c8.102 0 14.669-6.568 14.669-14.669v-6.854c0-23.773-19.272-43.045-43.045-43.045-23.773 0-43.045 19.272-43.045 43.045v21.523z",
    fill: "url(#SVGID_60_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.159 464.868h46.032c5.222 0 9.454-4.233 9.454-9.454v-4.417c0-15.322-12.421-27.743-27.743-27.743-15.322 0-27.743 12.421-27.743 27.743z",
    fill: "url(#SVGID_61_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchool);
export default __webpack_public_path__ + "static/media/icon-school.1f00bf4ad4499cec9a64489962eb7823.svg";
export { ForwardRef as ReactComponent };